import type {MetlSharedJobExport} from "../../../metl-models/exports/MetlSharedJobExport.ts";
import type {ScannedJobResult} from "../scan-operations/job/scanJobDetails.ts";
import type {OverallProblemIndicators} from "./ScanResult.tsx";
import type {SharedJobRow} from "../../../components/scanner/shared-job-scanner/SharedJobData.tsx";

export interface SingleSharedJobScanResult {
    metadata: MetlSharedJobExport["metadata"]
    problemIndicators: OverallProblemIndicators
    componentCount: Record<number, number>
    jobs: ScannedJobResult[]
}

export interface SharedJobDetailedScanResult {
    jobs: SingleSharedJobScanResult[]
    overall: {
        problemIndicators: OverallProblemIndicators
        componentCount: Record<number, number>
    }
    list: SharedJobRow[]
}

export interface SharedJobBasicScanResult {
    list: SharedJobRow[]
}

export function isDetailed(result: SharedJobScanResult): result is SharedJobDetailedScanResult {
    return "overall" in result
}

export type SharedJobScanResult = SharedJobBasicScanResult | SharedJobDetailedScanResult